import assignWith from "lodash/assignWith";

export class ServiceConfig {
  constructor(config, configArgs) {
    config = typeof config == "function" ? config(...configArgs) : config;
    config = config && (config instanceof Array ? config : [config]);

    this.config = config;
  }

  async callService(graphql) {
    if (!this.config) return;

    let mainServiceConfigs = this.config.map((curServiceConfig) =>
      assignWith({}, curServiceConfig, (objValue, srcValue) =>
        typeof srcValue == "function" ? srcValue() : srcValue
      )
    );

    await Promise.all(
      mainServiceConfigs.map(
        ({ axiosConfig, isMock, cache }) =>
          axiosConfig && graphql.callGql(axiosConfig, { isMock, cache })
      )
    );
  }
}

export function callDataloaderServiceFromConfig(dataloader, config) {
  config =
    typeof config == "string"
      ? {
          methodName: config,
        }
      : config ?? {};

  const { methodName, mainArgs, dataloaderOptions } = config;

  return dataloader[methodName]?.(...(mainArgs ?? []), dataloaderOptions);
}

export class DataloaderConfig {
  constructor(config, configArgs) {
    config = typeof config == "function" ? config(...configArgs) : config;

    this.config = config;
  }

  async callService(dataloader) {
    if (!this.config) return;

    let mainDataloaderConfig =
      typeof this.config == "function" ? this.config() : this.config;
    mainDataloaderConfig =
      mainDataloaderConfig instanceof Array
        ? mainDataloaderConfig
        : [mainDataloaderConfig];

    await Promise.all(
      mainDataloaderConfig.map((curDataloaderConfig) =>
        callDataloaderServiceFromConfig(dataloader, curDataloaderConfig)
      )
    );
  }
}
